import React, { Component } from "react";
import {
  Button,
  Dimmer,
  Form,
  Grid,
  Image,
  Loader,
  Message,
  Segment,
  Transition,
  Container
} from "semantic-ui-react";

import request from "../utils/request";
import logo from "../assets/img/bump-ticketlogo.png";
import moment from "moment";

const transitions = {
  init: "fade up",
  error: "shake"
};
class Login extends Component {
  constructor(props) {
    super(props);
    this.signIn = this.signIn.bind(this);
    this.state = {
      loaderVisible: false,
      username: "",
      password: "",
      errorVisible: "hidden",
      errorMessage: "",
      loaderMessage: "Authenticating...",
      visible: false,
      animation: transitions.init
    };
  }
  toggleVisibility = () => this.setState({ visible: !this.state.visible });
  componentDidMount() {
    if (this.props.loggedIn) this.redirect();
    setTimeout(this.toggleVisibility, 500);
  }
  signIn() {
    const { cookies } = this.props;
    var self = this;
    self.setState({
      animation: transitions.error,
      errorVisible: "hidden",
      errorMessage: "",
      loaderMessage: "Authenticating...",
      loaderVisible: true
    });

    return request
      .post(this, "api:/auth", {
        username: this.state.username,
        password: this.state.password
      })
      .catch(resp => {
        return resp;
      })
      .then(resp => {
        if (resp.error) {
          self.setState({ animation: transitions.error });
          self.toggleVisibility();
          self.setState({
            errorVisible: "",
            errorMessage: resp.message,
            loaderMessage: "Access Denied",
            loaderVisible: false
          });
        }
        if (resp.role && (resp.role !== 'admin' && resp.role !== 'manager')) {
            self.setState({
                animation: transitions.error
            });
            self.toggleVisibility();
            self.setState({
                errorVisible: "",
                errorMessage: "Access Denied",
                loaderMessage: "Access Denied",
                loaderVisible: false
            });
            return resp;
        }
        if (resp.access_token) {
          let cookieOpts = {
            path: "/",
            expires: moment.unix(resp.expiry).toDate()
          }
          cookies.set("accessToken", resp.access_token, cookieOpts);
          cookies.set("refreshToken", resp.refresh_token, cookieOpts);
          cookies.set("expiresAt", resp.expiry, cookieOpts);
          self.setState(
            {
              loaderMessage: "Redirecting..."
            },
            this.redirect
          );
        }
      });
  }
  redirect = () => {
    if (this.props.history.location.pathname === "/login") this.props.history.push("/");
  };
  render() {
    const {
      visible,
      animation,
      errorMessage,
      errorVisible,
      loaderVisible,
      loaderMessage
    } = this.state;

    return (
      <Container fluid id="wrapper" className="login">
        <Grid verticalAlign="middle" textAlign="center" padded id="login">
          <Grid.Column mobile={16} tablet={12} computer={6}>
            <Transition visible={visible} animation={animation} duration={500}>
              <Segment>
                <Dimmer inverted active={loaderVisible}>
                  <Loader>{loaderMessage}</Loader>
                </Dimmer>
                <h2>
                  <Image src={logo} size="small" centered alt="BumpCBN Logo" />
                </h2>
                <Message negative floating className={errorVisible}>
                  <p>{errorMessage}</p>
                </Message>
                <Form className="form-signin">
                  <Form.Input
                    onChange={e => this.setState({ username: e.target.value })}
                    placeholder="Enter your username"
                    value={this.state.username}
                    iconPosition="left"
                    name="username"
                    size="large"
                    icon="user"
                    fluid
                    autoFocus
                  />
                  <Form.Input
                    onChange={e => this.setState({ password: e.target.value })}
                    placeholder="Enter your password"
                    value={this.state.password}
                    iconPosition="left"
                    name="password"
                    type="password"
                    size="large"
                    icon="lock"
                    fluid
                  />
                  <Button primary type="submit" size="large" onClick={this.signIn}>
                    Login
                  </Button>
                </Form>
              </Segment>
            </Transition>
          </Grid.Column>
        </Grid>
      </Container>
    );
  }
}

export default Login;
